/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

function currenttab(tagg){
$('.tab-content.current .product-grid-slide').each(function(){
    if ($(this).hasClass(tagg)) {
    	$(this).show();
    }
    else{
    	$(this).hide();
    }
  });
}

function mobileslider(id){
  if($(window).width()<= 577){
          $(id).slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            arrows:false,
            dots: false,
            responsive: [
              {
                breakpoint: 577,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  infinite: true,
                  centerMode: false,
                  dots: false,
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  infinite: true,
                  centerMode: true,
                  dots: false,
                }
              }
             
              // You can unslick at a given breakpoint now by adding:
              // settings: "unslick"
              // instead of a settings object
            ]	
          });
          $(id).slick("setPosition");
      }
      else{
        if($(id).hasClass("slick-initialized")) {
          $(id).slick("unslick");
          $(id).removeClass("slick-initialized slick-slider");
        }
      }
}

$(function(){

  $('.tagdata:first').addClass('current');
  var tagg = $('.tagdata.current').attr('data_tag');
  currenttab(tagg);
 var tag  =  $('.shop_by_concern_wrap .tab-link.current').attr('data_tag_for');
   $('.tagdata').each(function(){
      	var tagfor = $(this).attr('data_tag_for');
        if(tagfor == tag ){
        	$(this).show();
        }
        else{
        	$(this).hide();
        }
      });
  var id = "#"+tag;
   if($(window).width()<= 577){
        if ($("#"+tag)[0]){
        }
        else{
      	$( '.tagdata[data_tag_for="'+tag+'"]' ).wrapAll( "<div class='panel current' id='"+tag+"'></div>" );
      var numItems = $("#"+tag).length;
          if(numItems < 3){
          setTimeout(function(){
      //mobileslider(id);
    $(".tagdata.current").parents('.panel.current').find('.slick-slide[data-slick-index="0"] .tagdata').trigger('click')

      },100);
          }
        }
        
      }
 		//mobileslider(id);
$(".tagdata.current").trigger('click');
    $(".tagdata.current").parents('.panel.current').find('.slick-slide[data-slick-index="0"] .tagdata').trigger('click')

});


	$(document).on('click','.shop_by_concern_wrap .tab-link',function(){
		var tag = $(this).attr('data_tag_for');
      $('.tagdata').each(function(){
      	var tagfor = $(this).attr('data_tag_for');
        if(tagfor == tag ){
        	$(this).show();
        }
        else{
        	$(this).hide();
        }
      });
      var id = "#"+tag;
      $('.tagdata').removeClass('current');
      
   
    var tagg = $('.tagdata[data_tag_for="'+tag+'"]:first').addClass('current').attr('data_tag');
	
      setTimeout(function(){
      currenttab(tagg);
    $(".tagdata.current").parents('.panel.current').find('.slick-slide[data-slick-index="0"] .tagdata').trigger('click')

      },100);
      if($(window).width()<= 577){
        if ($("#"+tag)[0]){
        }
        else{
      	$( '.tagdata[data_tag_for="'+tag+'"]' ).wrapAll( "<div class='panel current' id='"+tag+"'></div>" );
      var numItems = $("#"+tag).length;
          if(numItems < 3){
          setTimeout(function(){
     // mobileslider(id);
    $(".tagdata.current").parents('.panel.current').find('.slick-slide[data-slick-index="0"] .tagdata').trigger('click')

      },100);
               var slideno = 0;

            
          }
        }
        
      }
     $(".tagdata.current").trigger('click');

     
    });

$(document).on('click','.tagdata',function(){
	var tagg = $(this).attr('data_tag');
  	$('.tagdata').removeClass('current');
    $(this).addClass('current');
  currenttab(tagg);
});


$(window).resize(function(){
 var tag  =  $('.shop_by_concern_wrap .tab-link.current').attr('data_tag_for');

 var id = "#"+tag;
   if($(window).width()<= 577){
        if ($("#"+tag)[0]){
        }
        else{
      	$( '.tagdata[data_tag_for="'+tag+'"]' ).wrapAll( "<div class='panel current' id='"+tag+"'></div>" );
      var numItems = $("#"+tag).length;
          if(numItems < 3){
          setTimeout(function(){
     // mobileslider(id);
    $(".tagdata.current").parents('.panel.current').find('.slick-slide[data-slick-index="0"] .tagdata').trigger('click')

      },100);
          }
        }
        
      }
  
  else{
 $(".tagdata").unwrap();
    $( '.tagdata' ).wrapAll( "<div class='tag_wrap'></div>" );


  //$( '.tagdata[data_tag_for="'+tag+'"]' ).wrapAll( "<div class='panel current' id='"+tag+"'></div>" );
// $('.tagdata:first').addClass('current');
//   var tagg = $('.tagdata.current').attr('data_tag');
//   currenttab(tagg);
//  var tag  =  $('.shop_by_concern_wrap .tab-link.current').attr('data_tag_for');
//    $('.tagdata').each(function(){
//       	var tagfor = $(this).attr('data_tag_for');
//         if(tagfor == tag ){
//         	$(this).show();
//         }
//         else{
//         	$(this).hide();
//         }
//       });
    
  }
  
 		//mobileslider(id);
  
//   jul 13 update from karan
  
//   if(document.querySelectorAll('.custom-addToCart-Available').length > 0){
//     document.querySelectorAll('.custom-addToCart-Available').forEach(item => {
//       item.addEventListener('click', (e) => {
//         var thisItem = item;
//         var vid = e.target.getAttribute('data-vid');
//         var src = e.target.getAttribute('data-src');
//         var title = e.target.getAttribute('data-title');
//         addToCart(vid, 1, src, title, thisItem);
//       });
//     })
//   }
  
  

});

$(document).on('click','.custom-addToCart-Available', function(){
    var thisItem = $(this);
    var vid = thisItem.attr('data-vid');
    var src =  thisItem.attr('data-src');
    var title =  thisItem.attr('data-title');
    addToCart(vid, 1, src, title, thisItem);
  })


  $(document).on('click','.popdown__close__inner', function(){
	$('.product-add-popdown').removeClass('is-visible');
  })

  var t = document.querySelector('[data-drawer-toggle="drawer-cart"]');
  t.addEventListener(
    "click",
    function (t) {
      t.preventDefault(), this.drawer.classList.remove("is-visible"), e.dispatchEvent(new CustomEvent("theme:drawer:open", { bubbles: !1 }));
    }.bind(this)
  );
  
  function addToCart(vid, qty, src, title, thisItem) {
     thisItem.html('<span class="DotLoadingAddToCart" <svg="" viewbox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="50"><svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="50"></circle></svg><svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="50"></circle></svg><svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="50"></circle></svg></circle></span>');
    //      thisItem.html('<span class="DotLoadingAddToCart"<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="50"/></svg><svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="50"/></svg><svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="50"/></svg></span>');
    $.ajax({
      type: "POST",
      url: '/cart/add.js',
      dataType: 'json',
      data: {
        id: vid,
        quantity: qty
      },
      success: function(){


        if(document.querySelectorAll('.product-add-popdown').length > 0){
          document.querySelector('.product-add-popdown').classList.add('is-visible');
          setTimeout(function(){
            document.querySelector('.product-add-popdown').classList.remove('is-visible');
                         $('[data-drawer-toggle="drawer-cart"]').trigger("click");
            //             $('.header__mobile__button[data-drawer-toggle="drawer-cart"]').trigger("click");
          }, 3000)

          var appendHtml = '<div class="product__popdown__outer"><div class="product__popdown__textbar"><span class="product__popdown__title product__popdown__title--bold">'+title+'</span><span class="product__popdown__title">Default Title &nbsp;</span><span class="product__popdown__title product__popdown__title--bold">Added to cart </span></div><div class="wrapper"><div class="product__popdown__inner"><div class="product__popdown__close"><div class="popdown__close__inner" data-close-popdown=""><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close-small" viewBox="0 0 15 15"><g fill-rule="evenodd"><path d="M2.237 1.073l12.021 12.021-1.414 1.414L.824 2.488z"></path><path d="M.823 13.094l12.021-12.02 1.414 1.413-12.02 12.021z"></path></g></svg></div></div><div class="product__popdown__image"><img loading="lazy" alt="'+title+'" src="'+src+'" width="90" height="90"></div><div class="product__popdown__cart__wrapper"><a href="/cart" class="product__popdown__cart text-link uppercase" data-drawer-toggle="drawer-cart">View Cart</a></div></div></div></div>';

          $('.product-add-popdown').html(appendHtml);
          thisItem.html('<span class="DotLoadingAddToCart" <svg="" viewbox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="50"><svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="50"></circle></svg><svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="50"></circle></svg><svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="50"></circle></svg></circle></span>');
          $.get(window.theme.routes.cart + ".js")
          .then((t) => {
            document.dispatchEvent(new CustomEvent("theme:cart:change", { detail: { cart: t.data }, bubbles: !0 }));
            thisItem.html('added');

            setTimeout(function(){
              thisItem.html('Add To Cart');	
            },2000)
          })
          .catch((t) => {
            console.error(t);
          });
        }
      }

    });
  }